module.exports = __webpack_public_path__ + "static/media/ccus_guide_1.39386b60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ccus_guide_1.svg
// module id = 13480
// module chunks = 0